module.exports = __webpack_public_path__ + "static/img/versatile-framework_256.322b325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/versatile-framework_256.png
// module id = xEwI
// module chunks = 0